import { ActionButton, Button, Content, Dialog, Divider, Flex, Footer, Heading, Text } from '@adobe/react-spectrum'
import './Offline/Offline.scss'
import ContactCenter from "../../../Apps/ContactCenter/Modules/ContactCenter";
import { useDispatch } from 'react-redux';
import { CallIcon } from './Offline/icons';
import React from 'react'
import Vip from '../../../Theme/Styles/Icons/vip-icon';

export const IncomingCall = (props: any) => {
    const { incomingCallData, darkMode } = props
    const dispatch = useDispatch()
    const acceptCall = () => {
        dispatch({ type: 'INCOMING_CALL', payload: { openPopup: "no" } })
        ContactCenter.acceptIncomingCall()
    }
    const data = incomingCallData.message.content;
    const isVIPQueue = data?.queueJourney?.value?.includes('VIP');
    React.useEffect(() => {
        try {
            const logString1 = `INCOMING_CALL : Pop up Component Mounted in OAC`
            window.connect.getLog().info("%s", logString1)
        } catch (e: any) {
            console.log('ERROR on Incoming logging :', e)
        }
    }, [])
    return (
        <Dialog size='S' UNSAFE_className='offline-popover' width={600} height={400}>
            <Heading UNSAFE_style={{ display: 'flex', alignItems: 'center'}}>
                <ActionButton UNSAFE_className={'telephony-call'} right="10px" bottom="5px">
                    <CallIcon />
                </ActionButton>
                {incomingCallData.message.title}
                {isVIPQueue ? (
                    <div style={{ marginLeft: '350px' }}>
                        <Vip isDark={darkMode} />
                    </div>
                ) : null}
            </Heading>
            <Divider />
            <Content>
                <Text UNSAFE_className={`incoming-call-text ${darkMode ? "dark-text" : "incoming-call-subhead"}`}>{incomingCallData.message.subtitle}</Text>
                <Flex UNSAFE_className='incoming-call-content' direction='column' marginTop={27} height={117} >
                    {
                        Object.keys(data)
                            .filter(item => item !== 'isDirectorOrAbove') // Exclude isDirectorOrAbove from display
                            .map((item: any, index: any) => {
                            return (
                                <Flex direction="row" key={index}>
                                    <Text UNSAFE_className={`incoming-call-text ${darkMode ? "dark-text" : "incoming-call-text-key"} `} width={100} justifySelf="flex-start">{data[item].name}</Text>
                                    <Flex direction="row" alignItems="center" marginStart={36}>
                                        <Text UNSAFE_className={`incoming-call-text ${darkMode ? "dark-text" : "incoming-call-text-value"} `}>: {data[item].value}</Text>
                                        {item === 'customerName' && data.isDirectorOrAbove === 'true' && (
                                            <span 
                                                style={{ 
                                                    color: '#ff0000', 
                                                    fontSize: '12px', 
                                                    fontWeight: 'bold', 
                                                    marginLeft: '4px' 
                                                }} 
                                                title="Director and Above"
                                            >
                                                ★
                                            </span>
                                        )}
                                    </Flex>
                                </Flex>
                            )
                        })
                    }
                </Flex>
            </Content>
            <Footer UNSAFE_className='incoming-call-button-group'>
                <Button variant='cta' onPress={acceptCall}><CallIcon />{incomingCallData.message.btnValue}</Button>
            </Footer>
        </Dialog>
    )
}

